define('lib/view/BookingUrlBuilder',['require','__original__/BookingUrlBuilder'],function (require) {
	
	var Parent = require('__original__/BookingUrlBuilder');
	
	/**
	 * Booking URL builder based on BokingModel data
	 */
	var BookingUrlBuilder = Parent.extend({
		
		/**
		 * Builds booking step url based on booking model data and extra params (extParams)
		 * 
		 * @param Object extParam
		 * @return String
		 */
		_buildStepUrl: function (extParams) {
			var isGroupBookingActive = Config.getInstance().getPluginStatus('group_booking');
			var params = ['location', 'category', 'service', 'count', 'addons', 'provider', 'date', 'time', 'wl'];
			if (Config.getInstance().getTimelineType() === Config.TIMELINE_CLASSES_PLUGIN) {
                params = ['location', 'category', 'service', 'count', 'addons', 'date', 'time', 'provider', 'wl'];
			}

			var urlParams = _.extend({}, this._getUrlParams(), extParams);

			if(!urlParams['service'] && urlParams['count'] && !isGroupBookingActive){
				urlParams['count'] = 1;
			}
			
			var result = '';
			for (var i = 0; i < params.length; i++) {
				var param = params[i];
				if (urlParams[param]) {
					result += param + '/' + urlParams[param] + '/';
				}
			}
			
			return result;
		}
		
	});
	
	/**
	 * Singleton implementation
	 */
	BookingUrlBuilder._instance = null;
	
	/**
	 * Returns BookingUrlBuilder instance
	 * 
	 * @return BookingUrlBuilder
	 */
	BookingUrlBuilder.getInstance = function () {
		if (!BookingUrlBuilder._instance) {
			BookingUrlBuilder._instance = new BookingUrlBuilder();
		}
		
		return BookingUrlBuilder._instance;
	};
	
	return BookingUrlBuilder;
	
});
